import { connect } from "react-redux";
import { ClanEditDialogs } from "UIKit";
import { checkNameOrTagAvailability } from "../Actions/ActionClanCreate";
import { changeClanAttributes, changeClanColor, updateClanEditState } from "../Actions/ActionClanEdit";
import { closeClanDescriptionEditDialog, closeClanNameEditDialog, closeClanRulesDialog, openClanRulesDialog } from "../Actions/ActionClanProfile";
import { finishCheckAvailabilityRenamingClan, renameClan, singleCheckRenamingClanStatus, startCheckAvailabilityRenamingClan, updateFieldValueRenamingClan } from "../Actions/ActionClanRename";
import { hideDialog, showDialog } from "../Actions/ActionDialog";

const mapStateToProps = (state, ownProps) => {
  const currentAccountClanId = state.currentAccount.clanId;
  const clan = state.clans.items[currentAccountClanId];
  return {
    dialogType: ownProps.dialogType,
    clansRulesContent: state.content.clansRulesPage,
    currentAccount: state.currentAccount,
    clanEdit: state.clanEdit,
    clanRename: state.clanRename,
    clan
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openClanRulesDialog: () => {
      dispatch(closeClanNameEditDialog());
      dispatch(closeClanDescriptionEditDialog());
      dispatch(openClanRulesDialog());
    },
    closeClanRulesDialog: () => {
      dispatch(closeClanRulesDialog());
    },
    closeClanDescriptionEditDialog: () => {
      dispatch(closeClanDescriptionEditDialog());
    },
    onEditDescriptionFormSubmit: data => {
      dispatch(changeClanAttributes(data)).then(isSuccess => {
        isSuccess && dispatch(hideDialog());
        isSuccess && dispatch(closeClanDescriptionEditDialog());
        isSuccess && dispatch(closeClanNameEditDialog());
      });
    },
    onEditColorSubmit: data => {
      dispatch(changeClanColor(data)).then(isSuccess => {
        isSuccess && dispatch(hideDialog());
        isSuccess && dispatch(closeClanDescriptionEditDialog());
        isSuccess && dispatch(closeClanNameEditDialog());
      });
    },
    onRenameClanSubmit: data => {
      dispatch(renameClan(data)).then(isSuccess => {
        isSuccess && dispatch(hideDialog());
        isSuccess && dispatch(closeClanDescriptionEditDialog());
        isSuccess && dispatch(closeClanNameEditDialog());
      });
    },
    onValidateOnServer: (field, value) => {
      dispatch(startCheckAvailabilityRenamingClan(field));
      return dispatch(checkNameOrTagAvailability(field, value, finishCheckAvailabilityRenamingClan));
    },
    checkRenamingClanStatus: () => dispatch(singleCheckRenamingClanStatus()),
    onUpdateFieldValue: (field, value, error) => dispatch(updateFieldValueRenamingClan(field, value, error)),
    onShowDialog: (content, size) => dispatch(showDialog(content, size)),
    onHideDialog: () => {
      dispatch(closeClanDescriptionEditDialog());
      dispatch(closeClanNameEditDialog());
      dispatch(hideDialog());
    },
    saveDialogState: (type, data) => dispatch(updateClanEditState(type, data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClanEditDialogs);